import styled, {css} from "styled-components"

import padding from "@irati/ui/src/global/padding"
import {ValidationButton} from "@irati/ui/src/FormItem"

interface StyledTab {
  isActive: boolean
}

export const StyledTabs = styled.div`
  display: flex;
  margin-bottom: ${({theme}) => `-${theme.spacing.two}`};
`

export const StyledTab = styled.div<StyledTab>`
  ${({theme}) => css`
    border-bottom: 2px solid;
    border-color: ${(props) => (props.isActive ? theme.colors.brand.default : "transparent")};
    cursor: pointer;
    padding: 0 ${theme.spacing.one} 10px;
  `}
`

export const StyledButton = styled(ValidationButton)`
  margin-right: ${padding.tiny};
`

interface StyledDivProps {
  height: number
  width: number
}

export const StyledPreview = styled.div<StyledDivProps>`
  display: flex;
  height: ${(props) => props.height}px;
  margin: 0 auto;
  width: ${(props) => props.width}px;
`
